var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4279 3.333C25.2379 3.121 24.9669 3 24.6829 3H5.3169C5.0329 3 4.7619 3.121 4.5719 3.333C4.3819 3.545 4.2919 3.828 4.3229 4.11L6.5249 23.933C6.5689 24.336 6.8539 24.673 7.2439 24.784L14.7239 26.921C14.8139 26.947 14.9069 26.96 14.9989 26.96C15.0909 26.96 15.1839 26.947 15.2739 26.921L22.7539 24.784C23.1439 24.673 23.4279 24.336 23.4729 23.933L25.6759 4.11C25.7079 3.828 25.6179 3.545 25.4279 3.333ZM20.6289 10.43H11.6989L11.9109 12.972H20.4139L19.7759 20.482L15.0029 22L14.9559 21.985L10.2359 20.48L9.9779 17.42H12.2899L12.3909 18.609L15.0279 19.19L17.6189 18.608L17.8939 15.395H9.8039L9.1779 8H20.8369L20.6289 10.43Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/Html5.a4843487b20778bc625787aaa373de9e.svg";
export { ForwardRef as ReactComponent };